/**
 * 后端菜单 name 偶发乱码/??? 时，按 component(path) 兜底展示名（与 router meta.title 一致）
 */
var COMPONENT_TITLE = {
  '/dashboard/data-screen': '数据大屏'
};
function walkMenus(list) {
  if (!list || !list.length) return;
  list.forEach(function (item) {
    var comp = item.path || '';
    var fixed = COMPONENT_TITLE[comp];
    if (fixed) {
      item.title = fixed;
    }
    if (item.children && item.children.length) {
      walkMenus(item.children);
    }
  });
}
export function patchKnownMenuTitles(menuList) {
  walkMenus(menuList);
}